/**
 * @description 配置
 */
const setting = require('./setting.config')
const network = require('./net.config')
const appconfig = require('./app.config')

module.exports = Object.assign({}, setting, network, appconfig)